import React from 'react';
import { Clock } from 'lucide-react';
import { useAppConfig } from '@/hooks/useAppConfig';

interface MessageHeaderProps {
  showTimestamp?: boolean;
  timestamp: Date;
  pageRoute?: string;
}

const MessageHeader: React.FC<MessageHeaderProps> = ({
  showTimestamp = true,
  timestamp,
  pageRoute = 'home'
}) => {
  const { getPageAgentLabel } = useAppConfig();
  
  const formatTime = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  };

  // Get agent label from config, fallback to default
  const agentLabel = getPageAgentLabel(pageRoute) || 'Parts Agent';

  return (
    <div className="message-header">
      <div className="sender-info">
        <span className="sender-name">{agentLabel}</span>
        <span className="sender-type">AI</span>
      </div>
      
      {showTimestamp && (
        <div className="timestamp-wrapper">
          <Clock size={12} className="timestamp-icon" />
          <span className="timestamp">{formatTime(timestamp)}</span>
        </div>
      )}
    </div>
  );
};

export default MessageHeader;
